import { useCallback, useEffect, useState } from "react"

import { CoreConfig } from "@cirrus/core/src/shared/config"

import { TranslationsService } from "./service"
import { LanguageCode, TranslationsState } from "./types"

export const useTranslationsChanger = ({
                                         getTranslations,
                                         persistLanguage
                                       }: Omit<TranslationsService, "translate" | "getDefaultLanguage">) => {
  const [state, setState] = useState(new TranslationsState())

  useEffect(() => {
    if (!state.translations) return
    sessionStorage.setItem("i18n", JSON.stringify(state))
  }, [state])

  const changeLanguage = useCallback((language: LanguageCode) => {
    if (state.translations?.[language]) {
      setState((prev) => ({ ...prev, language }))

    } else {
      setState((prev) => ({ ...prev, loading: true, error: null }))

      getTranslations(language).then(({ data }) => {
        setState((prev) => ({
          language,
          loading: false,
          error: null,
          translations: {
            ...prev.translations,
            [language]: data
          }
        }))
      }).catch((error) => setState((prev) => ({
        ...prev, loading: false, error
      })))
    }

    persistLanguage(language)
    document.documentElement.setAttribute("lang", CoreConfig.params.i18n.locales.byCode[language].shorthand)
  }, [persistLanguage, getTranslations, state.translations])

  return {
    state, changeLanguage
  }
}
